document.addEventListener("DOMContentLoaded", function() {
    function toggleSpanVisibility() {
        if (window.innerWidth <= 991) {
            // Get all h4 elements inside the list items
            const headings = document.querySelectorAll(".benefits_mobile h4");

            // Add a click event listener to each h4 element
            headings.forEach(function(heading) {
                heading.addEventListener("click", function() {
                    // Toggle the visibility of the next sibling span element
                    const span = this.nextElementSibling;
                    const listItem = this.parentElement; // Get the parent li element

                    if (span.style.display === "none" || span.style.display === "") {
                        span.style.display = "block";
                        listItem.classList.add("open"); // Add the "open" class to li
                    } else {
                        span.style.display = "none";
                        listItem.classList.remove("open"); // Remove the "open" class from li
                    }
                });
            });
        }
    }

    // Run the function initially
    toggleSpanVisibility();

    // Add an event listener for window resize to recheck the condition
    window.addEventListener("resize", function() {
        toggleSpanVisibility();
    });
});